import { API_REQUEST } from 'constants/apiActions';
import checkRetryError from 'helpers/checkRetryError';
import checkExpiredTokenError from 'helpers/checkExpiredTokenError';
import refreshToken from 'redux/actions/users/refreshToken';
import handleAxiosError from 'helpers/handleAxiosError';
import axiosHelper from 'helpers/axiosHelper';

const pendingActions = {};

const { REACT_APP_REAL_TIME_SERVICES_URL } = process.env;

export default ({ dispatch, getState }) => next => async ({
  type = '',
  payload = {},
}) => {
  if (type !== API_REQUEST) {
    return next({ type, payload });
  }
  try {
    if (
      !payload.httpOptions?.url?.includes(
        REACT_APP_REAL_TIME_SERVICES_URL,
      )
    ) {
      if (!pendingActions[payload.url]) {
        pendingActions[payload.url] = { data: payload.data };
      } else {
        return;
      }
    }
    if (typeof payload.onStart === 'function') {
      await payload.onStart()(dispatch);
    }
    const { data } = await axiosHelper(payload.httpOptions).request({
      method: payload.method.toLowerCase(),
      url: payload.url,
      data: payload.data,
      params: payload.queries,
    });

    delete pendingActions[payload.url];

    if (typeof payload.onSuccess === 'function') {
      await payload.onSuccess(data)(dispatch);
    }
  } catch (e) {
    delete pendingActions[payload.url];
    const error = handleAxiosError(e);
    if (checkRetryError(error)) {
      return dispatch({ type, payload });
    } else if (checkExpiredTokenError(error)) {
      refreshToken({ type, payload })(dispatch);
      return;
    } else if (typeof payload.onFailure === 'function') {
      await payload.onFailure(error)(dispatch);
    }
  }
  if (typeof payload.onEnd === 'function') {
    await payload.onEnd()(dispatch);
  }
  return getState();
};
